import styled from 'styled-components';
import {basicColor, font} from '@/styles/template';

export const BreadcrumbContainer = styled.div`
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    color: ${basicColor.white};
    opacity: 0.6;
`;

export const BreadcrumbItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const BreadcrumbLink = styled.a`
    color: inherit;
    transition: all 0.2s ease-out;
    border-bottom: 1px solid transparent;
    ${font.basicS}
    letter-spacing: 0.5px;
    padding-bottom: 0.3rem;
    
    &:hover {
        border-bottom: 1px solid ${basicColor.white};
    }
`;

export const BreadcrumbSeparator = styled.i`
    position: relative;
    display: block;
    width: 20px;
    height: 20px;
  
    &::before {
        content: '';
        display: block;
        width: 3px;
        height: 3px;
        border-radius: 10px;
        background-color: ${basicColor.white};
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
    }
`;
